var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"toggleable":"sm","type":"light","variant":"light"}},[_c('b-navbar-nav',{staticClass:"mr-auto"},[_vm._t("extras")],2),_c('b-navbar-nav',{staticClass:"ml-auto"},[_vm._t("items")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }